import footer from './footer';
import branches from './branches';
import imgAlt from './imgAlt';

export default {
  footer, branches, imgAlt
}



// WEBPACK FOOTER //
// ./src/texts/general/index.js